import React, { useEffect, useState } from "react";
import {
  TextField,
  Button,
  Container,
  Box,
  FormGroup,
  FormControlLabel,
  Stack,
  Checkbox,
  InputLabel,
  Select,
  MenuItem,
  FormControl,
  Snackbar,
  Alert,
  Stepper,
  Step,
  StepLabel,
  Typography,
  InputAdornment,
  Autocomplete,
  CircularProgress,
} from "@mui/material";
import { green } from "@mui/material/colors";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import "../App.css";
// import Navbar from "../components/Navbar";
import PageHeader from "../components/PageHeader";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Footer from "../components/Footer";
import ImageUploader from "../components/ImageUploader";
import _ from "lodash";
import { createRequest, getAllCategories } from "../apis";
import FmdGoodOutlinedIcon from "@mui/icons-material/FmdGoodOutlined";
import PaymentsOutlinedIcon from "@mui/icons-material/PaymentsOutlined";
import usePlacesAutocomplete, {
  getGeocode,
  getLatLng,
} from "use-places-autocomplete";
import { isMobile } from "react-device-detect";
import LogoImage from "../assets/Images/Vector.png";

const CreateRequest = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const {
    ready,
    value,
    suggestions: { status, data },
    setValue,
    clearSuggestions,
  } = usePlacesAutocomplete({
    requestOptions: {
      /* Define search scope here */
    },
    debounce: 300,
  });

  const steps = ["Task Details", "Time & Date", "Address"];
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [enteredTitle, setEnteredTitle] = useState("");
  const [enteredDetails, setEnteredDetails] = useState("");
  const [urgentCheck, setUrgentCheck] = useState(false);
  const [images, setImages] = useState([]);
  const [category, setCategory] = useState("");
  const [subCategory, setSubCategory] = useState("");
  const [openSnack, setOpenSnack] = useState(false);
  const [activeStep, setActiveStep] = useState(0);
  const [address, setAddress] = useState("");
  const [budget, setBudget] = useState("");
  const [categoriesData, setCategoriesData] = useState([]);
  const [categories, setCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [buttonLoading, setButtonLoading] = useState(false);
  // const [autoCompleteList, setAutoCompleteList] = useState([]);

  useEffect(() => {
    let user = {};
    user = JSON.parse(localStorage.getItem("user-info"));

    if (location.state?.requestParam) {
      setCategory(location.state.requestParam);
    }
    const fetchData = async () => {
      const response = await getAllCategories();
      setCategoriesData(response.data.categories);
      let arr = [];
      response.data.categories.map((item) => {
        arr.push({ label: item.name, value: item.name });
      });
      setCategories(arr);
    };
    fetchData();
  }, []);

  const postRequestHandler = async () => {
    setButtonLoading(true);
    let user = {};
    user = JSON.parse(localStorage.getItem("user-info"));

    if (address == "" || budget == "") {
      setOpenSnack(true);
      setButtonLoading(false);
      return;
    } else {
      if (_.isEmpty(user)) {
        const payload = {
          userid: "",
          category: category,
          subCategory: subCategory,
          title: enteredTitle,
          details: enteredDetails,
          images: images,
          urgent: urgentCheck,
          fromDate: fromDate,
          toDate: toDate,
          status: "active",
          address: address,
          budget: budget,
          email: "",
          creatorName: "",
          personal: false,
          to: "",
        };
        localStorage.setItem("createRequest", JSON.stringify(payload));
        localStorage.setItem("createRequestStatus", "true");

        navigate("/login");
      }
      const payload = {
        userid: user.googleId ? user.googleId : user._id,
        category: category,
        subCategory: subCategory,
        title: enteredTitle,
        details: enteredDetails,
        images: images,
        urgent: urgentCheck,
        fromDate: fromDate,
        toDate: toDate,
        status: "active",
        address: address,
        budget: budget,
        email: user.email,
        creatorName: user.googleId ? user.name : user.fullName,
        personal: false,
        to: "",
      };

      let data = await createRequest(payload);
      setButtonLoading(false);
      if (data) {
        navigate("/request-submitted");
      }
    }
    // if (
    //   category == "" ||
    //   subCategory == "" ||
    //   enteredTitle == "" ||
    //   enteredDetails == "" ||
    //   images.length == 0
    // ) {
    //   setOpenSnack(true);
    //   return;
    // }
    // if (urgentCheck == false) {
    //   if (fromDate == null) {
    //     setOpenSnack(true);
    //     return;
    //   } else {
    //     const payload = {
    //       userid: user.googleId ? user.googleId : user._id,
    //       category: category,
    //       subCategory: subCategory,
    //       title: enteredTitle,
    //       details: enteredDetails,
    //       images: images,
    //       urgent: urgentCheck,
    //       fromDate: fromDate,
    //       toDate: toDate,
    //       status: "active",
    //     };
    //     let data = await createRequest(payload);
    //     if (data) {
    //       navigate("/request-submitted");
    //     }
    //   }
    // } else {
    //   const payload = {
    //     userid: user.googleId ? user.googleId : user._id,
    //     category: category,
    //     subCategory: subCategory,
    //     title: enteredTitle,
    //     details: enteredDetails,
    //     images: images,
    //     urgent: urgentCheck,
    //     fromDate: fromDate,
    //     toDate: toDate,
    //     status: "active",
    //   };
    // let data = await createRequest(payload);
    // if (data) {
    //   navigate("/request-submitted");
    // }
    //}
  };

  const childDataHandler = (data) => {
    setImages(data);
  };

  const handleChange = (event) => {
    setCategory(event.target.value);
    const filtereddata = categoriesData.filter(
      (item) => item.name == event.target.value
    );
    setSubCategories(filtereddata[0].subCategories);
  };

  const handleChangeSubCategory = (event) => {
    setSubCategory(event.target.value);
  };

  // const categories = [
  //   { label: "AC Services", value: "AC Services" },
  //   { label: "Cleaning Services", value: "Cleaning Services" },
  //   { label: "Salon and Self Care", value: "Salon and Self Care" },
  //   { label: "Plumbing Services", value: "Plumbing Services" },
  //   { label: "Electrician Services", value: "Electrician Services" },
  //   { label: "Appliances Maintenance", value: "Appliances Maintenance" },
  //   { label: "Packaging and Movers", value: "Packaging and Movers" },
  //   { label: "Pest Control", value: "Pest Control" },
  // ];

  // const subCategories =
  //   category == "AC Services"
  //     ? [
  //         { label: "AC Services", value: "AC Services" },
  //         { label: "AC Management", value: "AC Management" },
  //         { label: "AC Installation", value: "AC Installation" },
  //         { label: "Mounting & Dismounting", value: "Mounting & Dismounting" },
  //         { label: "Dispenser Fixing", value: "Dispenser Fixing" },
  //         { label: "General Services", value: "General Services" },
  //       ]
  //     : category == "Cleaning Services"
  //     ? [{ label: "Cleaning Services", value: "Cleaning Services" }]
  //     : category == "Salon and Self Care"
  //     ? [{ label: "Salon and Self Care", value: "Salon and Self Care" }]
  //     : category == "Plumbing Services"
  //     ? [{ label: "Plumbing Services", value: "Plumbing Services" }]
  //     : category == "Electrician Services"
  //     ? [{ label: "Electrician Services", value: "Electrician Services" }]
  //     : category == "Appliances Maintenance"
  //     ? [{ label: "Appliances Maintenance", value: "Appliances Maintenance" }]
  //     : category == "Packaging and Movers"
  //     ? [{ label: "Packaging and Movers", value: "Packaging and Movers" }]
  //     : category == "Pest Control"
  //     ? [{ label: "Pest Control", value: "Pest Control" }]
  //     : [];

  const handleClose = () => {
    setOpenSnack(false);
  };

  const continueHandler = () => {
    if (activeStep == 0) {
      if (
        category == "" ||
        subCategory == "" ||
        enteredTitle == "" ||
        enteredDetails == "" ||
        !(enteredTitle.length >= 15 && enteredTitle.length <= 80) ||
        !(enteredDetails.length >= 20 && enteredDetails.length <= 300)
      ) {
        console.log("length is =====>", enteredTitle.length);
        setOpenSnack(true);
        return;
      }
    }
    if (activeStep == 1) {
      if (urgentCheck == false) {
        if (fromDate == null) {
          setOpenSnack(true);
          return;
        }
      }
    }
    setActiveStep((currentActiveStep) => currentActiveStep + 1);
  };

  const backHandler = () => {
    setActiveStep((currentActiveStep) => currentActiveStep - 1);
  };

  const handleSelect =
    ({ description }) =>
    () => {
      // When user selects a place, we can replace the keyword without request data from API
      // by setting the second parameter to "false"
      setValue(description, false);
      setAddress(description);
      clearSuggestions();

      // Get latitude and longitude via utility functions
      getGeocode({ address: description }).then((results) => {
        const { lat, lng } = getLatLng(results[0]);
        console.log("📍 Coordinates: ", { lat, lng });
      });
    };

  const renderSuggestions = () =>
    data.map((suggestion) => {
      const {
        place_id,
        structured_formatting: { main_text, secondary_text },
      } = suggestion;

      return (
        // <li key={place_id} onClick={handleSelect(suggestion)}>
        //   <strong>{main_text}</strong> <small>{secondary_text}</small>
        // </li>
        <div
          style={{
            padding: "10px",
            borderBottom: "1px solid #EEEBEF",
            cursor: "pointer",
          }}
          onClick={handleSelect(suggestion)}
        >
          <Typography>
            {main_text}, {secondary_text}
          </Typography>
        </div>
      );
    });

  if (isMobile) {
    return (
      <Box
        sx={{ display: "flex" }}
        justifyContent="center"
        alignItems="center"
        style={{ height: "100vh" }}
      >
        <Stack direction="column">
          <Stack
            direction="row"
            spacing={1}
            alignItems="center"
            className="mb-5"
            justifyContent="center"
            style={{ width: "100%" }}
          >
            <img
              src={LogoImage}
              alt="logo"
              style={{ height: "33px", width: "50px" }}
            />
            <span
              className="default-color"
              style={{
                fontWeight: "bold",
                fontSize: "18px",
              }}
            >
              Amannat
            </span>
          </Stack>
          <Stack>
            <Typography>Please download the Ammanat Mobile App.</Typography>
          </Stack>
        </Stack>
      </Box>
    );
  }

  return (
    <>
      {/* <Navbar /> */}
      <PageHeader title="Post Request" crossIcon />
      <Container maxWidth="md">
        <Snackbar
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
          open={openSnack}
          autoHideDuration={2000}
          onClose={handleClose}
        >
          <Alert
            severity="error"
            sx={{ width: "100%" }}
            variant="filled"
            onClose={handleClose}
          >
            Please fill all of the required information in order to proceed!
          </Alert>
        </Snackbar>

        <Stack
          direction="row"
          spacing={2}
          alignItems="center"
          justifyContent="space-between"
          className="mb-16"
        >
          <Stack direction="row" spacing={1} alignItems="center">
            <div
              className={
                activeStep == 0
                  ? "currentStepContainer"
                  : "previousStepContainer"
              }
            >
              <span
                className={
                  activeStep == 0 ? "currentStepColor" : "previousStepColor"
                }
              >
                1
              </span>
            </div>
            <Typography>Task Details</Typography>
          </Stack>
          <hr style={{ width: "100px" }} />
          <Stack direction="row" spacing={1} alignItems="center">
            <div
              className={
                activeStep < 1
                  ? "nextStepContainer"
                  : activeStep == 1
                  ? "currentStepContainer"
                  : "previousStepContainer"
              }
            >
              <span
                className={
                  activeStep < 1
                    ? "nextStepColor"
                    : activeStep == 1
                    ? "currentStepColor"
                    : "previousStepColor"
                }
              >
                2
              </span>
            </div>
            <Typography
              style={activeStep < 1 ? { color: "#ccc9cf" } : { color: "black" }}
            >
              Time & Date
            </Typography>
          </Stack>
          <hr style={{ width: "100px" }} />
          <Stack direction="row" spacing={1} alignItems="center">
            <div
              className={
                activeStep < 2
                  ? "nextStepContainer"
                  : activeStep == 2
                  ? "currentStepContainer"
                  : "previousStepContainer"
              }
            >
              <span
                className={
                  activeStep < 2
                    ? "nextStepColor"
                    : activeStep == 2
                    ? "currentStepColor"
                    : "previousStepColor"
                }
              >
                3
              </span>
            </div>
            <Typography
              style={activeStep < 2 ? { color: "#ccc9cf" } : { color: "black" }}
            >
              Address & Payment
            </Typography>
          </Stack>
        </Stack>

        {activeStep == 0 ? (
          <Stack spacing={3} direction="column">
            <Stack
              direction={{ xs: "column", sm: "row" }}
              spacing={{ xs: 1, sm: 2, md: 6 }}
            >
              <Stack className="w-100" spacing={1}>
                <Typography className="field-label">Category</Typography>
                <FormControl fullWidth>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={category}
                    onChange={handleChange}
                    displayEmpty
                    // placeholder="Select Category"
                  >
                    <MenuItem disabled value="">
                      <em>Select Category</em>
                    </MenuItem>
                    {categories.map((item) => (
                      <MenuItem value={item.value}>{item.label}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Stack>
              <Stack className="w-100" spacing={1}>
                <Typography className="field-label">Sub Category</Typography>
                <FormControl fullWidth>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={subCategory}
                    onChange={handleChangeSubCategory}
                    displayEmpty
                  >
                    <MenuItem disabled value="">
                      <em>Select Subcategory</em>
                    </MenuItem>
                    {subCategories.map((item) => (
                      <MenuItem value={item.value}>{item.label}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Stack>
            </Stack>
            <Stack spacing={1}>
              <Stack>
                <Typography className="field-label">Task Title</Typography>
              </Stack>
              <TextField
                required
                size="small"
                id="outlined-basic"
                variant="outlined"
                className="w-100 "
                placeholder="Enter your task title"
                value={enteredTitle}
                onChange={(e) => setEnteredTitle(e.target.value)}
              />
              <Typography
                variant="body1"
                className="ammanat-darker-gray"
                style={
                  !(enteredTitle.length >= 15 && enteredTitle.length <= 80)
                    ? { fontSize: "12px", color: "red" }
                    : { fontSize: "12px" }
                }
              >
                15 - 80 characters
              </Typography>
            </Stack>
            <Stack spacing={1}>
              <Stack>
                <Typography className="field-label">Task Details</Typography>
              </Stack>
              <TextField
                required
                size="small"
                id="outlined-basic"
                variant="outlined"
                className="w-100 "
                placeholder="Enter your task details"
                multiline
                rows={3}
                value={enteredDetails}
                onChange={(e) => setEnteredDetails(e.target.value)}
              />
              <Typography
                variant="body1"
                className="ammanat-darker-gray"
                style={
                  !(enteredDetails.length >= 20 && enteredDetails.length <= 300)
                    ? { fontSize: "12px", color: "red" }
                    : { fontSize: "12px" }
                }
              >
                20 - 300 characters
              </Typography>
            </Stack>
            <ImageUploader
              passChildData={childDataHandler}
              heading="Add Images or Videos (Optional)"
            />
          </Stack>
        ) : activeStep == 1 ? (
          <Stack spacing={2} direction="column">
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <Stack direction="row" spacing={6}>
                <Stack spacing={1} className="w-100">
                  <Typography className="field-label">From</Typography>
                  <DesktopDatePicker
                    value={fromDate}
                    minDate={new Date("2017-01-01")}
                    onChange={(newValue) => {
                      setFromDate(newValue);
                    }}
                    renderInput={(params) => (
                      <TextField {...params} size="small" />
                    )}
                    disabled={urgentCheck == true ? true : false}
                    disablePast
                  />
                </Stack>

                <Stack spacing={1} className="w-100">
                  <Typography className="field-label">To (Optional)</Typography>
                  <DesktopDatePicker
                    value={toDate}
                    minDate={
                      fromDate == null ? new Date("2017-01-01") : fromDate
                    }
                    onChange={(newValue) => {
                      setToDate(newValue);
                    }}
                    renderInput={(params) => (
                      <TextField {...params} size="small" />
                    )}
                    disabled={fromDate == null ? true : false}
                  />
                </Stack>
              </Stack>
            </LocalizationProvider>

            <FormGroup>
              <FormControlLabel
                control={
                  <Checkbox
                    onChange={(e) => {
                      setUrgentCheck(e.target.checked);
                      setFromDate(null);
                      setToDate(null);
                    }}
                    checked={urgentCheck ? true : false}
                    sx={{
                      "&.Mui-checked": {
                        color: green[500],
                      },
                    }}
                  />
                }
                label="I need this work to be urgently done."
              />
            </FormGroup>
          </Stack>
        ) : (
          <>
            <div className="mt-16">
              <Typography
                style={{ fontWeight: "bold" }}
                className="field-label"
              >
                Address
              </Typography>
              <TextField
                required
                size="small"
                variant="outlined"
                className="w-100"
                placeholder="Enter your address"
                value={value}
                disabled={!ready}
                onChange={(e) => {
                  setAddress(e.target.value);
                  setValue(e.target.value);
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <FmdGoodOutlinedIcon />
                    </InputAdornment>
                  ),
                }}
              />
              {/* We can use the "status" to decide whether we should display the dropdown or not */}
              {status === "OK" && (
                <div
                  style={{ border: "1px solid #EEEBEF", borderRadius: "6px" }}
                  className="mb-16"
                >
                  {renderSuggestions()}
                </div>
              )}
              <Typography
                style={{ fontWeight: "bold" }}
                className="mt-10 field-label"
              >
                Budget (Optional)
              </Typography>
              <TextField
                required
                size="small"
                variant="outlined"
                className="w-100"
                placeholder="Enter your budget"
                value={budget}
                onChange={(e) => setBudget(e.target.value)}
                type="number"
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <PaymentsOutlinedIcon />
                    </InputAdornment>
                  ),
                  startAdornment: (
                    <InputAdornment position="start">£</InputAdornment>
                  ),
                }}
              />
              <Typography className="mt-5">
                You can negotiate amount with the expert.
              </Typography>
            </div>
          </>
        )}

        <Box
          sx={{ display: "flex", flexDirection: "row", pt: 2 }}
          style={{ marginBottom: "20px", marginTop: "20px" }}
        >
          {activeStep == 0 ? (
            <Button
              sx={{ mr: 1 }}
              variant="outlined"
              style={{ textTransform: "capitalize" }}
              className="default-border default-color"
            >
              Cancel
            </Button>
          ) : (
            <Button
              sx={{ mr: 1 }}
              variant="outlined"
              style={{ textTransform: "capitalize" }}
              onClick={backHandler}
              className="default-border default-color"
            >
              Back
            </Button>
          )}

          <Box sx={{ flex: "1 1 auto" }} />

          {buttonLoading ? (
            <Button variant="contained" disabled className="primary-button">
              <CircularProgress style={{ color: "white" }} size={25} />
            </Button>
          ) : (
            <Button
              variant="contained"
              style={{ textTransform: "capitalize" }}
              onClick={
                activeStep === steps.length - 1
                  ? postRequestHandler
                  : continueHandler
              }
              className="primary-button"
            >
              {activeStep === steps.length - 1 ? "Post Request" : "Continue"}
            </Button>
          )}
        </Box>
      </Container>
      <Footer />
    </>
  );
};

export default CreateRequest;
